angular.module("avant.heap", ["avant.services"]);
require('./heapService.coffee');
